export class InputFocusoutEvent extends CustomEvent<never> {}
export class InputFocusinEvent extends CustomEvent<never> {}
export class InputChangedEvent extends CustomEvent<never> {}
export class InputShowEvent extends CustomEvent<boolean> {}
export class InputResetEvent extends CustomEvent<boolean> {}
export class InputResetAfterEvent extends CustomEvent<boolean> {}
